import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CreditoLimpio } from './pages/CreditoLimpio';
import { GluteLab } from './pages/GluteLab';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3fbjb53k17tvf">
      <Routes data-id="element-1" data-mp="3fb155f7ki1ab">
        <Route path="/" element={<CreditoLimpio data-id="element-3" data-mp="2rkx51htl8jo2" />} data-id="element-2" data-mp="3f8eyriwexrto" />
        <Route path="/glute-lab" element={<GluteLab data-id="element-5" data-mp="2rl6v15emuqtr" />} data-id="element-4" data-mp="2rk47n7gir6il" />
      </Routes>
    </BrowserRouter>;
}